import { NotifyMeButton } from "@/components/waitlist/NotifyMeButton";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Facebook, Instagram, Twitter } from "lucide-react";

const platforms = [
  { name: 'Facebook Shops', icon: Facebook },
  { name: 'Instagram', icon: Instagram },
  { name: 'Twitter', icon: Twitter },
];

export const SocialPlatformIntegration = () => (
  <Card>
    <CardHeader><CardTitle>Intégrations Réseaux Sociaux</CardTitle></CardHeader>
    <CardContent>
      <div className="grid gap-4">
        {platforms.map(({ name, icon: Icon }) => (
          <div key={name} className="flex flex-wrap items-center justify-between gap-3 p-4 border rounded-lg">
            <div className="flex items-center gap-3">
              <div className="p-2 rounded-full bg-muted text-muted-foreground"><Icon className="h-5 w-5" /></div>
              <span className="font-medium">{name}</span>
            </div>
            <div className="flex flex-wrap items-center gap-2"><Button variant="outline" disabled>Bientôt disponible</Button><NotifyMeButton channel={name} /></div>
          </div>
        ))}
      </div>
    </CardContent>
  </Card>
);
